import styles from "./LoadingGrid.module.css";

interface LoadingGridProps {
  size: "7x7" | "9x9";
}

export function LoadingGrid({ size }: LoadingGridProps) {
  const dim = size === "7x7" ? 7 : 9;

  // Create an ambiguous placeholder pattern — a mix of filled and empty cells
  // that looks like a crossword but reveals nothing about the actual puzzle
  const cells: boolean[][] = [];
  for (let r = 0; r < dim; r++) {
    const row: boolean[] = [];
    for (let c = 0; c < dim; c++) {
      // Simple cross pattern: center row, center col, and a few extras
      const mid = Math.floor(dim / 2);
      const isFilled =
        r === mid || c === mid || (r === 1 && c >= 1 && c <= dim - 2) || (r === dim - 2 && c >= 1 && c <= dim - 2);
      row.push(isFilled);
    }
    cells.push(row);
  }

  return (
    <div
      className={styles.grid}
      style={{ "--grid-cols": dim } as React.CSSProperties}
    >
      {cells.map((row, r) =>
        row.map((filled, c) => (
          <div
            key={`${r}-${c}`}
            className={filled ? styles.cell : styles.black}
          />
        ))
      )}
    </div>
  );
}
